module.exports = __webpack_public_path__ + "static/Christmas-Lights-67e36321852322549c0998435ffadb03.gif";